/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_HomeInputs */

const cs_documents_home = /** @type {(inputs: Documents_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumenty`)
};

const en_documents_home = /** @type {(inputs: Documents_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents`)
};

/**
* | output |
* | --- |
* | "Documents" |
*
* @param {Documents_HomeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_home = /** @type {((inputs?: Documents_HomeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_HomeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_home(inputs)
	return cs_documents_home(inputs)
});